/**
 * Content index — W66.X17
 *
 * Re-exports all content strings from content-strings.ts
 * (generated from the markdown source files in /content/).
 *
 * No ?raw imports — avoids TypeScript ambient module requirement.
 * All strings inlined at build time via content-strings.ts.
 *
 * Canon guardrails (CANON_VISUALS_LOCKED.md 2026-05-29):
 *   - 5-color palette: gray #6B7280, red #DC2626, orange #EA580C, yellow #EAB308, green #16A34A
 *   - Banned: "Nine Gates", "Floors" (use "Levels"), "Navy" as brand color,
 *             "Maybe" (use Yes/No/Unknown), "BANT", "MEDDIC", "Fit" as CP,
 *             "Compelling event" (use "firm/formal timeline"), "Cofounder" for Bryan
 *   - No exclamation points. No emojis. M-PACT hyphenated.
 *   - Bryan K. Short, Founder and CEO, Mi6 Group.
 *
 * W66.X17 locked: 2026-06-06
 */

export {
  endOfCrmManifesto,
  crmIntelligenceLayerManifesto,
  methodologyAsEngine,
  attiliusWhyDifferent,
  cp1Model,
  cp2Model,
  cp3Model,
  cp4Cp10Summaries,
} from "./content-strings";

export {
  LINKEDIN_ARTICLES,
  LINKEDIN_SECTION_LABELS,
  type LinkedInArticle,
  type LinkedInSection,
} from "./linkedin-articles";

/** Reference library catalog — used to populate the Reference Library page and sidebar. */
export const REFERENCE_LIBRARY = [
  {
    id: "methodology-as-engine",
    slug: "methodology-as-engine",
    title: "Methodology as Engine",
    category: "methodology" as const,
    description: "The doctrine that threads Sales Plan, M-PACT, and the platform into one operating surface.",
  },
  {
    id: "attilius-why-different",
    slug: "attilius-why-different",
    title: "Why Attilius Is Different",
    category: "methodology" as const,
    description: "The structural distinction between an intelligence platform and a CRM, and why it matters for enterprise sales.",
  },
  {
    id: "cp1-project",
    slug: "cp1-project",
    title: "CP1 — Project",
    category: "cp-model" as const,
    description: "Entry checkpoint. Is there a real project, and is this a new logo or an existing customer expansion?",
  },
  {
    id: "cp2-need-pain-demonstration",
    slug: "cp2-need-pain-demonstration",
    title: "CP2 — Need / Pain / Demonstration",
    category: "cp-model" as const,
    description: "The gravitational center of the methodology. Largest single checkpoint weight at 20 of 100.",
  },
  {
    id: "cp3-budget",
    slug: "cp3-budget",
    title: "CP3 — Budget",
    category: "cp-model" as const,
    description: "The three-state budget gate: Formal, Discretionary, or No budget. CP3 confirms the money exists; CP6 confirms it will be released.",
  },
  {
    id: "cp4-cp10-summaries",
    slug: "cp4-cp10-summaries",
    title: "CP4 through CP10 — Summaries",
    category: "cp-model" as const,
    description: "Timeline, Authority, Sign-off, Org Map, Competitive Position, Compliance, and Legal — the execution and closing half of M-PACT.",
  },
  {
    id: "end-of-crm",
    slug: "end-of-crm",
    title: "The End of the CRM Era",
    category: "manifesto" as const,
    description: "Why the CRM model fails enterprise solution selling, and what M-PACT replaces it with.",
  },
  {
    id: "crm-intelligence-layer",
    slug: "crm-intelligence-layer",
    title: "The Intelligence Layer",
    category: "manifesto" as const,
    description: "The structural difference between recording what happened and knowing what to do next.",
  },
  {
    id: "four-role-walkthrough",
    slug: "four-role-walkthrough",
    title: "Four Roles. One System. One Day.",
    category: "storyboard" as const,
    description: "A day-in-the-life walkthrough of the platform from the BDR, AE, Manager, and Marketing perspectives \u2014 with the coaching beats highlighted.",
  },
] as const;

export type ContentCategory = "methodology" | "cp-model" | "manifesto" | "storyboard";
export type ReferenceItem = (typeof REFERENCE_LIBRARY)[number];
